const cacheKeys = {
  all: ['contacts'],
  list: () => [...cacheKeys.all, 'list']
}

export default {
  endpoint: '/contacts',
  cacheKeys
}
